import { useEffect } from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from 'react-router';
import { ToastProvider } from '@koyomi/ui';
import './i18n.ts';
import { router } from './router.tsx';
import { useAdminAuth } from './auth-store.ts';
import { refreshAdminSession } from '../lib/api.ts';

const queryClient = new QueryClient({ defaultOptions: { queries: { retry: 1, staleTime: 15_000, refetchOnWindowFocus: false } } });

export function App() {
  const status = useAdminAuth((s) => s.status);
  useEffect(() => {
    if (status !== 'booting') return;
    void refreshAdminSession().then((ok) => { if (!ok) useAdminAuth.getState().setAnonymous(); });
  }, [status]);
  return (
    <QueryClientProvider client={queryClient}>
      <ToastProvider>
        <RouterProvider router={router} />
      </ToastProvider>
    </QueryClientProvider>
  );
}
